var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/require-default-props */
import React, { useRef } from 'react';
import classNames from 'classnames';
/**
 * Shared keyboard event handler for inline edit components
 * Handles Enter and Escape keys
 */
export const handleInlineEditKeyDown = (e) => {
    var _a, _b;
    if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        (_a = e.currentTarget) === null || _a === void 0 ? void 0 : _a.blur();
    }
    else if (e.key === 'Escape') {
        e.preventDefault();
        (_b = e.currentTarget) === null || _b === void 0 ? void 0 : _b.blur();
    }
};
/**
 * Generates className string for inline edit components
 */
export const getInlineEditClassNames = (variantClass, width, multiline, className, disableEdit) => {
    const widthClass = width === 'full' ? 'qmb-ui-inline-edit--x-full' : '';
    const multilineClass = multiline ? 'qmb-ui-inline-edit--multiline' : '';
    return classNames({ [variantClass]: !disableEdit }, widthClass, multilineClass, className);
};
/**
 * InlineEditBase - Internal shared component
 * DO NOT EXPORT from module barrel exports
 * Used only by InlineText and InlineDate components
 *
 * This is not a standalone component but provides shared functionality
 * for inline editing components.
 */
export function InlineEditBase(_a) {
    var { as, children, className, variantClass, width = 'auto', multiline = false, disableEdit = false, placeholder = '--', label, spellCheck = true, id, 'aria-labelledby': ariaLabelledby } = _a, props = __rest(_a, ["as", "children", "className", "variantClass", "width", "multiline", "disableEdit", "placeholder", "label", "spellCheck", "id", 'aria-labelledby']);
    const contentRef = useRef(null);
    const Component = as || 'div';
    const handleFocus = () => {
        // Add focus handling logic here if needed
    };
    const handleBlur = () => {
        // Add blur handling logic here if needed
    };
    const handleKeyDown = (e) => {
        handleInlineEditKeyDown(e);
    };
    const computedClassName = classNames('qmb-ui-inline-edit', getInlineEditClassNames(variantClass, width, multiline, className, disableEdit));
    return (React.createElement(Component, Object.assign({ ref: contentRef, className: computedClassName, contentEditable: !disableEdit, suppressContentEditableWarning: true, onFocus: handleFocus, onBlur: handleBlur, onKeyDown: handleKeyDown, "data-placeholder": placeholder, "data-label": label, spellCheck: spellCheck, id: id, tabIndex: disableEdit ? -1 : 0, "aria-labelledby": ariaLabelledby }, props), children));
}
